import React from 'react';

const Loader = () => {
  return (
    <>
      <style>
        {`
          .circle-loader {
            width: 50px;
            aspect-ratio: 1;
            border-radius: 50%;
            border: 8px solid transparent;
            border-right-color: #FA5629;
            position: relative;
            animation: spinLoader 1s infinite linear;
          }

          .circle-loader::before,
          .circle-loader::after {
            content: "";
            position: absolute;
            inset: -8px;
            border-radius: 50%;
            border: inherit;
            animation: inherit;
          }

          .circle-loader::before {
            animation-duration: 2s;
            opacity: 0.7;
          }

          .circle-loader::after {
            animation-duration: 4s;
            opacity: 0.4;
          }

          @keyframes spinLoader {
            100% {
              transform: rotate(1turn);
            }
          }
        `}
      </style>

      <div className="flex items-center justify-center w-full h-full">
        <div className="circle-loader" />
      </div>
    </>
  );
};

export default Loader;
